/// <summary>
/// This object provides js functions for new vcTreeMenu based on jgGrid <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 01.05.2025<br />
/// Copyright ©: EUDT GmbH 2025 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 01.05.2025                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality for the new vcTreeMenu                       *<br />
/// **********************************************************************<br />
/// </summary>

jQuery.widget("bluaul.vcTreeMenu3", jQuery.common.vcBaseV4, {
    vcV: new vcVisual(),
    vcC: new vcCommon(),

    defaultOptions: {
        vcgid: '0000',
        dataModel: "",
        day: "",
        startDate: "",
        endDate: "",
        selInterval: 1,
        h: 500, w: 250, showAllAtStart: false, showNotAssigned: true, showTickets: true, data: null, chartType: "",
        startIndex: -1, // holds the index of the row, which shall be preselected after initialization
        useCachedData: false, // checks if cachedData is available and shall be loaded
        cachedTreeData: null, // holds the cached data
        clearFilter: false, callback: function () { }
    },

    fullData: null, // holds the entire data with all bsaids
    errorData: null, // holds the error data
    aqsErrorState: false, // tracks if AQS error is active - prevents updateErrors from overwriting warning icons
    selTagSignalList: null, // list with signals for selected entry
    cachedFullData: null, // holds the cached full data with all bsaids
    cachedFormattedData: null, // holds the cached data which is already formatted for the tree
    cachedErrorData: null, // holds the cached error data
    initialized: false, // indicates if the tree is initialized
    callback: function () { },

    _create: function () {
        this._createVisual(386);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vctree-menu-3");
            me._buildHtml();

            me.options = $.extend({}, me.defaultOptions, me.options);

            return true;
        } catch (e) { me.writeError('_initHTML', e); return false; }
    },

    _initEvents: function () {
        var me = this;
        try {
            me._initTree();

            // we bind the events directly to the tree
            me.myHtml.tree.tree.on('expandrow.jqGrid', function (event, rowid) {
                me.myHtml.tree.tree.find('#' + rowid).addClass('tree-parent-expanded');
            });

            me.myHtml.tree.tree.on('collapserow.jqGrid', function (event, rowid) {
                me.myHtml.tree.tree.find('#' + rowid).removeClass('tree-parent-expanded');
            });

        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        var me = this;
        try {
            me.myHtml = { cont: {}, tree: {}, menu: {} };

            me.myHtml.cont = $("<div>").attr("id", "container-" + me.options.vcgid).addClass("treeContainer");

            let obj = me.myHtml.menu;
            obj.btnReload = $("<div>").attr("id", "btn-reload-" + me.options.vcgid).addClass("button-toggle").css("width", "60px").css("height", "20px").css("display", "none").html("reload");

            obj = me.myHtml.tree;
            obj.wrapper = me._setObj("", "ui-jqgrid-tree vc-grid-margin-bottom").css("width", me.options.w).css("height", me.options.h);

            // we create a unique id for the tree table to avoid conflicts when multiple instances of vcTreeMenu3 are used on the same page
            obj.tree = $("<table>").attr("id", "tbl-tree-" + me.options.vcgid);
            obj.wrapper.append(obj.tree);

            me.myHtml.cont.append(me.myHtml.tree.wrapper, me.myHtml.menu.btnReload);
            me.myRoot.append(me.myHtml.cont);

        } catch (e) { me._writeErr(e); }
    },

    _initTree: function () {
        /// <summary>
        /// initializes the jqgrid tree; sets the configuration of the tree and fills the tree with data
        /// </summary>
        var me = this;
        try {
            // if cachedData is available for the currently selected menu button, load cachedData
            if (me.options.useCachedData && me.options.cachedTreeData) {
                me.fullData = me.options.cachedTreeData.fullData;
                me._getUpdateforErrorData(true);
                return;
            }

            // get data from database, if cached data is not available
            me.getData({ dataModel: me.options.dataModel, day: me.options.day, startDate: me.options.startDate, endDate: me.options.endDate, ChartType: me.options.chartType }, function (result) {
                me.fullData = JSON.parse(result);

                // save the error data for correct error counting (amount of signals with any kind of error)
                me.errorData = me.fullData.map(item => {
                    const errors = JSON.parse(item.errors || "[]");
                    const errorCount = JSON.parse(item.errorCount || "0");
                    const errMissing = JSON.parse(item.errMissing || "[]");
                    const errUnplaus = JSON.parse(item.errUnplaus || "[]");
                    const errInvalid = JSON.parse(item.errInvalid || "[]");

                    return {
                        category_id: item.category_id,
                        errors,
                        errorCount,
                        errMissing,
                        errUnplaus,
                        errInvalid
                    };
                });

                var formattedData = me._formatDataForTree(me.fullData);

                // save data for reloading, if menu button is selected again
                me.cachedFormattedData = formattedData;
                me.cachedFullData = me.fullData;
                me.cachedErrorData = me.errorData;

                var myData = { rows: formattedData };

                // check if any node has children
                me.myHtml.tree.wrapper.removeClass("vc-no-tree-icons");
                const hasTreeIcons = formattedData.some(row => !row.isLeaf);
                if (!hasTreeIcons) me.myHtml.tree.wrapper.addClass("vc-no-tree-icons"); // if no children, placeholder for expand/collapse icon must be deactivated

                me._renderTreeGrid(myData);
            });

        } catch (e) { me._writeError(e); }
    },

    _formatDataForTree: function (data) {
        /// <summary>
        /// formats the data for the tree - adds level, isLeaf, expanded and formats the errors column
        /// </summary>
        var me = this;
        try {
            var processedData = me._calculateLevels(data, null, 0);
            var formattedData = processedData.map(item => ({
                myid: item.category_id,
                icon: item.icon,
                name: item.name,
                iconClass: item.iconClass,
                parentid: item.parentId, // must be null, if no parent! otherwise getRootNodes is not working!
                errors: (function () { const s = me._getCompleteErrorString(item); return s ? s : "";  })(), 
                level: item.level, // add level
                isLeaf: !data.some(child => child.parentId === item.category_id),
                expanded: false,
                host: item.host,
                active: item.active // state of hardware or any other tag
            }));

            return formattedData;

        } catch (e) { me._writeError(e); }
    },


    _renderTreeGrid: function (myData) {
        /// <summary>
        /// renders the jqgrid tree with the given data
        /// </summary>
        var me = this;
        try {

            //configure the jqgrid
            me.myHtml.tree.tree.jqGrid(me._configureTreeGrid());

            //add data
            me.myHtml.tree.tree[0].addJSONData(myData);
            //hide header
            me.myHtml.tree.wrapper.find(".ui-jqgrid-hdiv").hide();
            //collapse all nodes
            me.myHtml.tree.tree.jqGrid('collapseAll');

            // check if scrollbar is available; if shown, add css class for layout
            let $gridBody = me.myHtml.tree.tree.closest(".ui-jqgrid-bdiv")[0];

            if ('ResizeObserver' in window) {
                const ro = new ResizeObserver(() => {
                    const hasScrollbar = $gridBody.scrollHeight > $gridBody.clientHeight;
                    me.myHtml.tree.wrapper.toggleClass("has-scrollbar", hasScrollbar);
                });
                ro.observe($gridBody);
            }

            // preselects desired row, if startIndex is given
            if (me.options.startIndex != -1) me.myHtml.tree.tree.jqGrid("setSelection", me.myHtml.tree.tree.jqGrid("getDataIDs")[me.options.startIndex], true);

            me.options.callback({ "type": "init" });

            me.initialized = true; 

            // get currently selected row id
            var selectedRowId = me.myHtml.tree.tree.jqGrid('getGridParam', 'selrow');
            me._getBsaidsForTag(selectedRowId);

        } catch (e) { me._writeErr(e); return false; }
    },


    _configureTreeGrid: function () {
        var me = this;
        try {
            // calculate column widths based on grid width
            const gridWidth = me.options.w;
            const scrollbarPadding = 5;
            const iconWidth = 16;

            const scrollbarWidth = (function () {
                let div = document.createElement('div');
                div.style.overflow = 'scroll';
                div.style.visibility = 'hidden';
                div.style.position = 'absolute';
                div.style.width = '100px';
                div.style.height = '100px';
                document.body.appendChild(div);
                let width = div.offsetWidth - div.clientWidth;
                document.body.removeChild(div);
                return width;
            })();

            const errorColWidth = Math.floor(gridWidth * 0.18);
            const nameColWidth = gridWidth - iconWidth - errorColWidth - scrollbarWidth;

            const gridId = "tbl-tree-" + me.options.vcgid; // we create a unique grid ID for the tree to avoid conflicts when multiple instances of vcTreeMenu3 are used on the same page

            return {
                autoencode: false,
                "colModel": [
                    { name: "myid", index: "myid", sorttype: "int", key: true, hidden: true },
                    { name: "icon", index: "icon", sorttype: "string", hidden: true, label: "Icon", width: iconWidth, fixed: true, formatter: "html" },
                    {
                        name: "name", index: "name", sorttype: "string", label: "Name", width: nameColWidth, classes: 'multiline-cell', formatter: function (cellvalue, options, rowObject) {
                            let iconHtml = "";
                            if (rowObject.iconClass && rowObject.iconClass !== "") {
                                iconHtml = `<i class="${rowObject.iconClass} vc-tree-menu-icon"></i>`;
                            }

                            const isInactive = rowObject.active === false;
                            const nameLine = `<span class="vc-tree-menu-text">${cellvalue}</span>`;
                            const hostLine = rowObject.host && rowObject.host !== "0" && rowObject.host !== ""
                                ? `<div class="vc-tree-menu-host">${rowObject.host}</div>` : "";

                            return `<div class="vc-tree-menu-wrapper" style="${isInactive ? 'color: #aaa;' : ''}">${iconHtml}<div class="vc-tree-menu-content">${nameLine}${hostLine}</div></div>`;
                        }
                    },
                    {
                        name: "errors", index: "errors", sorttype: "string", label: "Errors", width: errorColWidth, align: "right", classes: 'vc-tree-menu-errors',
                        formatter: function (cellvalue, options, rowObject) {
                            var n = me._normalizeErrorsValue(cellvalue);
                            if (!n.ok) return "";
                            if (n.aqsError) return "<i class='fa fa-triangle-exclamation icon-color-error' title='" + me.specific.resources.aqsErrorWarning_lbl + "'></i>";
                            if ((n.err === 0) && (n.warn === 0)) return "";
                            return me._formatErrorsHtml(n.err, n.warn);
                        },
                        unformat: function (cellvalue, options, cell) {
                            var txt = $(cell).text().trim();
                            var n = me._normalizeErrorsValue(txt);
                            return n.ok ? n.raw : "";
                        },
                        cellattr: function (rowId, val, rawObject, cm, rdata) {
                            var n = me._normalizeErrorsValue(val);
                            if (!n.ok) {
                                return 'title="" style="background-color: white !important; padding-right: 5px; font-weight: 500;"';
                            }
                            var tooltip = (me.specific && me.specific.resources)
                                ? (me.specific.resources.invalid + "/" + me.specific.resources.missing + ": " + n.err + ", " + me.specific.resources.implausible + ": " + n.warn)
                                : ("Invalid/Missing: " + n.err + ", Implausible: " + n.warn);
                            return 'title="' + tooltip + '" style="background-color: white !important; padding-right: 5px; font-weight: 500;"';
                        }

                    },
                    { name: "parentid", hidden: true },
                    { name: "level", hidden: true, align: "right" },
                    { name: "isLeaf", hidden: true },
                    { name: "expanded", hidden: true }
                ],
                rowattr: function (rd) {
                    let levelClass = `tree-row-level-${rd.level}`;
                    let expandStateClass = '';
                    if (rd.level === 0 && rd.expanded === true) {
                        expandStateClass = 'tree-parent-expanded';
                    }
                    return { "class": `${levelClass} ${expandStateClass}` };
                },

                gridComplete: function () {
                    try {
                        var ids = me.myHtml.tree.tree.jqGrid('getDataIDs');
                        ids.forEach(function (id) {
                            // we search for the cell in the errors column and update the title attribute with the correct tooltip
                            var $cell = me.myHtml.tree.tree.find('tr.jqgrow[id="' + id + '"] td[aria-describedby="' + gridId + '_errors"]');
                            if (!$cell.length) return;

                            var row = me.myHtml.tree.tree.jqGrid('getLocalRow', id);
                            if (!row) return;

                            var rawVal = row.errors;
                            if (String(rawVal).trim() === "AQS_ERROR") return;

                            var n = me._normalizeErrorsValue(rawVal);
                            if (n.ok) {
                                if (row.errors !== n.raw) {
                                    row.errors = n.raw;
                                    me.myHtml.tree.tree.jqGrid('setRowData', id, { errors: n.raw });
                                }
                            } else {
                                me.myHtml.tree.tree.jqGrid('setRowData', id, { errors: "" });
                            }
                        });
                    } catch (_) { }
                },

                "width": me.options.w, "height": me.options.h, "hoverrows": true, shrinkToFit: false,
                "viewrecords": false, "gridview": true, "sortorder": "asc", "datatype": "json",
                "sortname": "name", "loadonce": false, "rowNum": 100, "scrollrows": true,
                "treeGrid": true, "ExpandColumn": "name", "treedatatype": "json", "treeGridModel": "adjacency",
                "treeReader": {
                    parent_id_field: "parentid",
                    "level_field": "level",
                    "leaf_field": "isLeaf",
                    "expanded_field": "expanded",
                    "loaded": "loaded"
                },

                onCellSelect: function (id, col) { me._getBsaidsForTag(id); },
            };
        } catch (e) { me._writeError(e); }
    },


    _getBsaidsForTag: function (id) {
        /// <summary>
        /// Gets all bsaids, which are mapped to the currently selected tag/entry
        /// Sends the list with all bsaids for the selected tag to the archive
        /// </summary>
        var me = this;
        try {
            for (var i = 0; i < me.fullData.length; i++) {       
                if (String(me.fullData[i].category_id) === String(id)) {
                    var bsaids = me.fullData[i].bsaids;
                    var list = [];

                    if (bsaids == null || bsaids === "" || bsaids === "null") {
                        list = [];
                    } else if (Array.isArray(bsaids)) {
                        list = bsaids;
                    } else {
                        try { list = JSON.parse(bsaids); }
                        catch (e) { list = []; }
                    }

                    me.selTagSignalList = list;
                    me.options.callback({ "type": "update", "value": me.selTagSignalList });
                    return;
                }
            }
            
            me.options.callback({ "type": "update", "value": [] });         

        } catch (e) { me._writeError(e); return false; }
    },


    _calculateLevels: function (data, parentId, currentLevel) {
        /// <summary>
        /// Calculates the levels for each tree entry (parent, children, etc)
        /// </summary>
        try {
            var me = this;
            let result = [];

            data.forEach(item => {
                if (item.parentId === parentId) {
                    const newItem = { ...item, level: currentLevel };
                    result.push(newItem);

                    const children = me._calculateLevels(data, item.category_id, currentLevel + 1);
                    result = result.concat(children);
                }
            });

            return result;
        } catch (e) { me._writeError(e); return false; }
    },

    setHeight: function (newHeight) {
        /// <summary>
        /// Public function to set the height of the jqGrid Tree from outside (archive)
        /// </summary>
        var me = this;
        try {
            me.options.h = newHeight;
            if (me.myHtml && me.myHtml.tree && me.myHtml.tree.wrapper) me.myHtml.tree.wrapper.css("height", newHeight);
            if (me.myHtml.tree.tree && me.myHtml.tree.tree.length > 0) me.myHtml.tree.tree.jqGrid("setGridHeight", newHeight);
        } catch (e) { me._writeError("setHeight", e); }
    },

    _getCompleteErrorString: function (item) {
        /// <summary>
        /// gets the complete error string for the errors column - depending on the selected interval
        /// </summary>
        var me = this;
        try {
            if (me.options.selInterval == 1) {
                const invalid = JSON.parse(item.errInvalid || "[]") || [];
                const missing = JSON.parse(item.errMissing || "[]") || [];
                const unplaus = JSON.parse(item.errUnplaus || "[]") || [];

                const err = new Set(invalid.concat(missing)).size;
                const warn = unplaus.length;

                return (err + warn) > 0 ? `${err}/${warn}` : "";
            }
            else
                return "";
        } catch (e) { me._writeErr(e); }
    },

    getUpdatedErrorData: function (startDate, endDate) {
        var me = this;
        try {
            if (startDate && endDate) {
                me.options.startDate = startDate;
                me.options.endDate = endDate;
                me.options.day = endDate;
            }
            else if (startDate && typeof startDate === "object") {
                me.options.startDate = startDate.startDate || me.options.startDate;
                me.options.endDate = startDate.endDate || me.options.endDate;
                me.options.day = me.options.endDate;
            }
            else {
                me.options.day = startDate;
                me.options.startDate = startDate;
                me.options.endDate = startDate;
            }

            me._getUpdateforErrorData(false);

        } catch (e) {
            me.writeError("getUpdatedErrorData", e);
            return false;
        }
    },


    _getUpdateforErrorData: function (reloadTree) {
        /// <summary>
        /// gets the current error data from the db and updates the errorData array
        /// </summary>
        var me = this;
        try {
            me.getData({ day: me.options.day, startDate: me.options.startDate, endDate: me.options.endDate, ChartType: me.options.chartType }, function (result) {

                // if new error data is empty, everything needs to be updated correctly
                if (!result || !Array.isArray(result.rows)) {
                    const newErrorData = [];

                    for (const item of me.fullData) {
                        const emptyErrorInfo = {
                            category_id: item.category_id,
                            errors: [],
                            errorCount: 0,
                            errMissing: [],
                            errUnplaus: [],
                            errInvalid: []
                        };

                        newErrorData.push(emptyErrorInfo);

                        const fullItem = me.fullData.find(f => f.category_id === item.category_id);
                        if (fullItem) {
                            fullItem.errors = JSON.stringify([]);
                            fullItem.errorCount = "0";
                            fullItem.errMissing = JSON.stringify([]);
                            fullItem.errUnplaus = JSON.stringify([]);
                            fullItem.errInvalid = JSON.stringify([]);
                        }
                    }

                    me.errorData = newErrorData;                    
                    if (reloadTree) me._updateTreeAgain();
                    return;
                }


                // if error data is not empty, we fill in the new data
                const errorMap = new Map();
                const missingErrorIds = new Set();
                const unplausErrorIds = new Set();
                const invalidErrorIds = new Set();


                for (const err of result.rows) {
                    errorMap.set(err.id, err);

                    // we remove rule errors, if dataModel is 1
                    if (me.options.dataModel === 1 && err.isrule) continue;
                    // we check all other conditions for missing, invalid and implausible
                    if (err.missing === true && err.ignoreLeaks === false) { missingErrorIds.add(err.id); }
                    if (err.valid === false && err.ignoreLeaks === false) { invalidErrorIds.add(err.id); }
                    if (err.plausible === false && err.ignorePlausible === false) { unplausErrorIds.add(err.id); }
                }

                const newErrorData = [];

                for (const item of me.fullData) {
                    const bsaids = JSON.parse(item.bsaids || "[]");

                    const matchedMissing = bsaids.filter(id => missingErrorIds.has(id));
                    const matchedInvalid = bsaids.filter(id => invalidErrorIds.has(id));
                    const matchedUnplaus = bsaids.filter(id => unplausErrorIds.has(id));

                    const matchedFaultySet = new Set([...matchedMissing, ...matchedInvalid]);
                    const matchedFaulty = [...matchedFaultySet];

                    const errorInfo = {
                        category_id: item.category_id,
                        errors: matchedFaulty,
                        errorCount: matchedFaulty.length,
                        errMissing: matchedMissing,
                        errUnplaus: matchedUnplaus,
                        errInvalid: matchedInvalid
                    };

                    newErrorData.push(errorInfo);

                    const fullItem = me.fullData.find(f => f.category_id === item.category_id);
                    if (fullItem) {
                        fullItem.errors = JSON.stringify(matchedFaulty);
                        fullItem.errorCount = JSON.stringify(matchedFaulty.length);
                        fullItem.errMissing = JSON.stringify(matchedMissing);
                        fullItem.errUnplaus = JSON.stringify(matchedUnplaus);
                        fullItem.errInvalid = JSON.stringify(matchedInvalid);
                    }
                }

                me.errorData = newErrorData;

                if (reloadTree)
                    me._updateTreeAgain();

            });

        } catch (e) { me._writeError(e); return false; }
    },

    _updateTreeAgain: function () {
        /// <summary>
        /// updates the tree again with the new data
        /// </summary>
        var me = this;
        try {

            // save data for reloading, if menu button is selected again
            me.cachedFormattedData = me._formatDataForTree(me.fullData);
            me.cachedFullData = me.fullData;
            me.cachedErrorData = me.errorData;

            var myData = { rows: me.cachedFormattedData };

            me._renderTreeGrid(myData);

        } catch (e) { me._writeErr(e); return false; }
    },


    updateErrors: function (filteredSignals, anyFilterActive, selInterval, isSingle) {
        /// <summary>
        /// Public function to count the error amount depending on the selected filters in the archive
        /// </summary>
        var me = this;
        try {

            if (!me.initialized) { return null; }

            // if AQS error is active, do not overwrite the warning icons with normal counts
            if (me.aqsErrorState) return;

            me.options.selInterval = selInterval;
            me.errorData.forEach(function (item) {
                var categoryId = item.category_id;

                var invalidErrors = item.errInvalid || [];
                var missingErrors = item.errMissing || [];
                var unplausErrors = item.errUnplaus || [];

                var countInvalidMissing = 0;
                var countUnplaus = 0;

                if (anyFilterActive) {
                    const signalSet = new Set(filteredSignals);

                    const uniqueInvalidMissing = new Set(
                        invalidErrors.concat(missingErrors).filter(id => signalSet.has(id))
                    );

                    countInvalidMissing = uniqueInvalidMissing.size;
                    countUnplaus = unplausErrors.filter(id => signalSet.has(id)).length;

                    if ((countInvalidMissing + countUnplaus) === 0) {
                        me.myHtml.tree.tree.jqGrid('setCell', categoryId, 'errors', " ");
                        me._updateErrorTitle(categoryId, "", "");
                        return;
                    }
                } else {
                    const uniqueInvalidMissing = new Set(invalidErrors.concat(missingErrors));

                    countInvalidMissing = uniqueInvalidMissing.size;
                    countUnplaus = unplausErrors.length;

                    if ((countInvalidMissing + countUnplaus) === 0) {
                        me.myHtml.tree.tree.jqGrid('setCell', categoryId, 'errors', " ");
                        me._updateErrorTitle(categoryId, "", "");
                        return;
                    }
                }

                const countString = `${countInvalidMissing}/${countUnplaus}`;
                me.myHtml.tree.tree.jqGrid('setRowData', categoryId, { errors: countString });
                me._updateErrorTitle(categoryId, countInvalidMissing, countUnplaus);
            });

        } catch (e) {
            me._writeError(e); return false;
        }
    },

    getInitializedState: function () {
        /// <summary>
        /// Public function to get the initialized state of the tree from outside (archive)
        /// </summary>
        return this.initialized;
    },

    saveTreeState: function () {
        /// <summary>
        /// saves the current tree state with all data and selections for reloading
        /// </summary>
        var me = this;
        try {

            //// if tree is not initialized, return null
            if (!me.initialized) { return null; }
            
            var tree = me.myHtml.tree.tree;
            var expandedNodes = [];
            var allRowIds = tree.jqGrid("getDataIDs");

            allRowIds.forEach(function (id) {
                var rowNode = $("#" + id);                
                if (rowNode.hasClass("tree-parent-expanded")) { expandedNodes.push(id); } // get expanded row
            });

            // get currently selected node
            var selectedNode = tree.jqGrid('getGridParam', 'selrow');

            return {
                expandedNodes: expandedNodes,
                selectedNode: selectedNode,
                formattedData: me.cachedFormattedData || [],
                fullData: me.cachedFullData || [],
                errorData: me.cachedErrorData || []
            };
        } catch (e) { me._writeError(e); return false; }
    },

    loadTreeState: function (savedState) {
        /// <summary>
        /// loads a cached tree state and sets the saved selections etc
        /// </summary>
        var me = this;
        try {
            if (!savedState) return;

            var tree = me.myHtml.tree.tree;           

            // expand all nodes, which are saved as expanded
            if (Array.isArray(savedState.expandedNodes)) {
                savedState.expandedNodes.forEach(function (rowId) {

                    var rowData = tree.jqGrid("getLocalRow", rowId);  // we get the whole data record, which is necessary for the expandNode

                    if (rowData) {
                        tree.jqGrid("expandNode", rowData);
                        tree.jqGrid("expandRow", rowId);

                        $('#' + rowId).addClass('tree-parent-expanded');
                        tree.trigger("reloadGrid"); // we update the tree for each node
                    }
                });
            }

            // select the node, which was selected before
            if (savedState.selectedNode) { tree.jqGrid("setSelection", savedState.selectedNode, true); }

        } catch (e) {
            me._writeError(e); return false;
        }
    },

    _updateErrorTitle: function (categoryId, countInvalidMissing, countUnplaus) {
        /// <summary>
        /// updates the text of the title for the errors correctly
        /// </summary>
        var me = this;
        try {
            var gridId = "tbl-tree-" + me.options.vcgid;
            let $cell = me.myHtml.tree.tree.find(`tr.jqgrow[id="${categoryId}"] td[aria-describedby="${gridId}_errors"]`);

            if ($cell.length > 0 && countInvalidMissing !== "" && countUnplaus !== "") {
                var err = me.specific.resources.invalid + "/" + me.specific.resources.missing + ": " + countInvalidMissing;
                var warn = me.specific.resources.implausible + ": " + countUnplaus;
                var sep = ",";
                let tooltip = `${err}${sep}${warn}`;
                $cell.attr('title', tooltip);
            } else {
                $cell.removeAttr('title');
            }

        } catch (e) {
            me._writeError(e); return false;
        }
    },

    setAqsError: function (hasError) {
        /// <summary>
        /// Public function - sets all errors cells to a warning icon (AQS_ERROR sentinel)
        /// or clears them when the error is resolved.
        /// </summary>
        var me = this;
        try {
            if (!me.initialized || !me.errorData) return;

            me.aqsErrorState = hasError; // store state so updateErrors does not overwrite the icon

            me.errorData.forEach(function (item) {
                if (hasError) {
                    // set sentinel value - the formatter will render the warning icon
                    me.myHtml.tree.tree.jqGrid('setRowData', item.category_id, { errors: "AQS_ERROR" });
                } else {
                    // clear the cell - updateErrors will fill correct counts afterwards
                    me.myHtml.tree.tree.jqGrid('setCell', item.category_id, 'errors', " ");
                    me._updateErrorTitle(item.category_id, "", "");
                }
            });

        } catch (e) { me._writeError(e); }
    },

    _normalizeErrorsValue: function (val) {
        /// <summary>
        /// Normalizes the value of the errors column to get the amount of errors and warnings
        /// </summary>
        try {
            if (val == null) return { ok: false, err: 0, warn: 0, raw: "" };

            // special sentinel for AQS fetch error - renders warning icon in cell
            if (String(val).trim() === "AQS_ERROR") {
                return { ok: true, aqsError: true, err: 0, warn: 0, raw: "AQS_ERROR" };
            }

            // remove html tags and trim
            var s = String(val)
                .replace(/<[^>]*>/g, "") 
                .replace(/&nbsp;|&#160;/gi, " ")
                .trim();

            if (!s) return { ok: false, err: 0, warn: 0, raw: "" };

            // check for format "X / Y"
            var m = s.match(/^\s*(\d+)\s*\/\s*(\d+)\s*$/);
            if (m) {
                return { ok: true, aqsError: false, err: parseInt(m[1], 10), warn: parseInt(m[2], 10), raw: m[1] + "/" + m[2] };
            }

            // check for format "X Y" (space separated)
            var nums = s.match(/\d+/g) || [];
            if (nums.length >= 2) {
                return { ok: true, aqsError: false, err: parseInt(nums[0], 10), warn: parseInt(nums[1], 10), raw: nums[0] + "/" + nums[1] };
            }

            return { ok: false, aqsError: false, err: 0, warn: 0, raw: "" };
        } catch (e) {
            return { ok: false, aqsError: false, err: 0, warn: 0, raw: "" };
        }
    },

    _formatErrorsHtml: function (err, warn) {
        /// <summary>
        /// Formats the html for the errors column with colors
        /// </summary>
        var e = isFinite(err) ? err : 0;
        var w = isFinite(warn) ? warn : 0;
        return '<span class="icon-color-error">' + e + '</span>'
            + '<span class="vc-tree-menu-error-separation">/</span>'
            + '<span class="icon-color-warning">' + w + '</span>';
    },


});
